window.addEventListener('scroll', function () {
    const header = document.querySelector('.l_header');
    const fv = document.querySelector('.js-fv');
    if (window.scrollY > fv.offsetHeight) {
        header.classList.add('is-active');
    } else {
        header.classList.remove('is-active');
    }
});
